import React, { PureComponent } from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import Img from 'gatsby-image';
import { compose } from 'redux';
import styled from 'styled-components';

import SocialButtons from '../landing-page/social-buttons';
import About from './about';
import Announcement from './announcement';
import Characters from './characters';
import Devices from './devices';
import Faq from './faq';
import Features from './features';
import Footer from './footer';
import ImportantNotification from './important-notification';
import Information from './information';
import Instructions from './instructions';
import jaLocale from './ja.locale';
import KeyVisual from './key-visual';
import { KomissaSaysSection } from './section';
import Splash from './splash';
import Story from './story';
import Trailer from './trailer';
import Warning from './warning';

/**
 * Container
 */
const Container = styled.div`
  color: white;
  width: 100%;
`;

const Background = styled(Img)`
  position: fixed !important;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  pointer-events: none;
  z-index: -1;
`;

const nImages = 3;

/**
 * Landing page
 */
class PsyLandingPage extends PureComponent {
  state = {
    loading: true,
    nLoadedImages: 0,
    shareUrl: ''
  };
  constructor(props) {
    super(props);
    this.props.addTranslationForLanguage(jaLocale, 'ja');
  }
  componentDidMount() {
    this.setState({
      shareUrl: window.location.href
    });
  }

  handleLoaded = () => {
    this.setState(({ loading, nLoadedImages }) => {
      nLoadedImages += 1;
      if (nLoadedImages >= nImages) {
        loading = false;
      }
      return {
        loading,
        nLoadedImages
      };
    });
  };

  render() {
    const { gameId, data } = this.props;
    const { loading, nLoadedImages } = this.state;
    return (
      <Container>
        <Translate>
          {({ translate }) => (
            <SocialButtons
              shareTitle={translate(`landingPage.games.${gameId}.title`)}
              shareUrl={this.state.shareUrl}
            />
          )}
        </Translate>
        <Splash
          loading={loading}
          nImages={nImages}
          nLoadedImages={nLoadedImages}
        />
        <Background
          fluid={data.backgroundImage.childImageSharp.fluid}
          onLoad={this.handleLoaded}
        />
        <Announcement />
        <ImportantNotification />
        <KeyVisual data={data} onLoad={this.handleLoaded} />
        <Story gameId={gameId} />
        <Features />
        <Trailer gameId={gameId} />
        <Instructions />
        <Characters />
        <About />
        <KomissaSaysSection>
          <Information gameId={gameId} />
          <Devices gameId={gameId} />
          <Faq gameId={gameId} />
          <Warning />
        </KomissaSaysSection>
        <Footer />
      </Container>
    );
  }
}

/**
 * Map Redux State to props
 */
const mapStateToProps = ({ global }) => ({
  gameId: global.gameId
});

export default compose(
  withLocalize,
  connect(mapStateToProps, null)
)(PsyLandingPage);
